import {InformationCircleIcon} from '@heroicons/react/outline';

type BusinessScopeNoticeProps = {
  /** Text before the enterprise name. */
  lead: string;
  name: string;
  /** Text after the enterprise name. */
  tail: string;
};

/** The info banner above an enterprise's own fees, rates or fee schedule. */
const BusinessScopeNotice = ({lead, name, tail}: BusinessScopeNoticeProps) => (
  <div className="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-dark-borderMid dark:bg-dark-blueBg">
    <InformationCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-cyan-500 dark:text-cyan-400" />
    <p className="text-sm text-gray-600 dark:text-gray-300">
      {lead}{' '}
      <span className="font-medium text-gray-800 dark:text-gray-100">
        {name}
      </span>
      {tail}
    </p>
  </div>
);

export default BusinessScopeNotice;
